export const infogram = () => {
  const components = document.querySelectorAll("[data-js-infogram]");

  if (!components?.length) {
    return;
  }

  for (const component of components) {
    initializeInfogramComponent(component);
  }
};

const initializeInfogramComponent = (component: Element) => {
  if (component.parentNode == null) {
    return;
  }

  // Below is a copy of the "Responsive (Async)" embed code from Infogram.com
  // that you're supposed to paste into your markup. It's modified to work
  // here instead, and now has readable variable names.

  // Not possible to use Infogram's window["InfogramEmbeds"] since their index expression
  // is not a number, and window type does not contain a definition of "InfogramEmbeds".
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const infogramEmbeds = (<any>window).InfogramEmbeds;
  if (infogramEmbeds && infogramEmbeds.initialized) {
    infogramEmbeds.process && infogramEmbeds.process();
  } else if (!document.getElementById("infogram-async")) {
    const scriptNode = document.createElement("script");
    scriptNode.async = true;
    scriptNode.id = "infogram-async";
    scriptNode.src = "https://e.infogram.com/js/dist/embed-loader-min.js";
    component.parentNode.insertBefore(scriptNode, component);
  }
};
